import React from "react";
import { Card } from "@mui/material";

import DashStations from "./components/DashStations";

function DashStationsStatus() {
  return (
    <Card sx={{ backgroundColor: "green" }}>
      <DashStations />
    </Card>
  );
}

export default DashStationsStatus;
